<div #scroller class="roller" role="list" aria-label="Lista kodów do usunięcia">
  @for (item of items(); track item.id) {
  <div class="code" role="listitem" [style.min-height]="rowHeight">
    <div class="code-info">
  <div class="product-details">
    <img
      class="brand-logo"
       [src]="item?.product?.images?.[0]?.url ?? ''"
          [alt]="item?.product?.brandName"
    />
    <div class="product-text">
      <span class="brand-name">{{ item?.product?.brandName }}</span>
      <span class="product-name font-bold">{{ item?.product?.name }}</span>
    </div>
  </div>
</div>

    <div class="code-price">
      <p class="font-bold text-center mt-0 mb-0 flip-price pl-1 pr-1">
        {{ item.flipPrice | priceFormat }} zł
      </p>
      <span class="start-price"
        >cena start:{{ item.startPrice | priceFormat }} zł</span
      >
    </div>
    <div class="reserve-container" >
      <button class="reserve-button" aria-label="Rezerwuj kod" (click)="onReserveClick($event, item)"> Rezerwuj </button>
      
    </div>
    <div class="timer">
      <app-user-code-timer
        [secondsLeft]="item.reelTimer"
        [startTimerFlag]="true"
      ></app-user-code-timer>
    </div>
  </div>
  } @if (items().length === 0) {
  <div class="empty">Brak pozycji.</div>
  }

  <!-- //----------------------------------------------------- -->
<!-- 
  @for (item of items(); track item.id) {
    <div class="row">
      <div class="col-md-8">
 <div class="code-info">
  <div class="product-details">
    <img
      class="brand-logo"
       [src]="item?.product?.images?.[0]?.url ?? ''"
          [alt]="item?.product?.brandName"
    />
    <div class="product-text">
      <span class="brand-name">{{ item?.product?.brandName }}</span>
      <span class="product-name font-bold">{{ item?.product?.name }}</span>
    </div>
  </div>
</div>

      </div>
      <div class="col-md-2">
        
            <div class="code-price">
      <p class="font-bold text-center mt-0 mb-0 flip-price pl-1 pr-1">
        {{ item.flipPrice | priceFormat }} zł
      </p>
      <span class="start-price"
        >cena start:{{ item.startPrice | priceFormat }} zł</span
      >
    </div>

      </div>
      <div class="col-md-1">
            <div class="reserve-button" (click)="onReserveClick($event, item)">
      Rezerwuj
    </div>

      </div>
      <div class="col-md-1">
        
           <div class="timer">
      <app-user-code-timer
        [secondsLeft]="item.reelTimer"
        [startTimerFlag]="true"
      ></app-user-code-timer>
    </div>

      </div>
    </div>
  }
   @if (items().length === 0) {
  <div class="empty">Brak pozycji.</div>
  } -->
</div>
